import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/icons-material/ChevronRight.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/IconButton/IconButton.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Link/Link.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/ListItem/ListItem.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Toolbar/Toolbar.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/apps/www-isdacreate-public-website/node_modules/@mui/material/Typography/Typography.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/builds/apps/www-isdacreate-public-website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/CreateiQ.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Facebook.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Footer Logo.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Header Logo.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/ISDA Logo.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Legal Data.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Linkedin.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Risks.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/SPGMI Globe.jpg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/SPGMI Logo White.png");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Twitter.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Use Cases.svg");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/public/images/Youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["AnnouncementBackground","AnnouncementGlobe","SPGMI_RED","LearnMoreButton"] */ "/builds/apps/www-isdacreate-public-website/src/components/AnnouncementBanner/AnnouncementBanner.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitsBackground","BenefitsSection"] */ "/builds/apps/www-isdacreate-public-website/src/components/Benefits/Benefits.styles.ts");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/src/components/ContactForm/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Quote","QuoteAttribution"] */ "/builds/apps/www-isdacreate-public-website/src/components/Feedback/Feedback.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["FooterBackground","FooterRow"] */ "/builds/apps/www-isdacreate-public-website/src/components/Footer/Footer.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["HeroBackground"] */ "/builds/apps/www-isdacreate-public-website/src/components/Hero/Hero.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationBar"] */ "/builds/apps/www-isdacreate-public-website/src/components/Navigation/Navigation.styles.ts");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/src/components/Navigation/SmoothScrollLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalloutBox"] */ "/builds/apps/www-isdacreate-public-website/src/components/Solutions/Solutions.styles.ts");
;
import(/* webpackMode: "eager" */ "/builds/apps/www-isdacreate-public-website/src/components/UseCases/UseCases.styles.ts");
